import { render } from "./GuardianThreadList.vue?vue&type=template&id=4502ddce&scoped=true"
import script from "./GuardianThreadList.vue?vue&type=script&lang=js"
export * from "./GuardianThreadList.vue?vue&type=script&lang=js"

import "./GuardianThreadList.vue?vue&type=style&index=0&id=4502ddce&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4502ddce"]])

export default __exports__